import { Grid as MuiGrid } from '@material-ui/core';
import React from 'react';

export const GridHalfSized: React.FC = ({ children }) => {
  return (
    <MuiGrid container spacing={3}>
      {React.Children.map(children, (child) => (
        <MuiGrid item xs={12} md={8} lg={8} xl={6}>
          {child}
        </MuiGrid>
      ))}
    </MuiGrid>
  );
};
